import { createContext, useCallback, useContext, useState } from "react";
import { Modal } from "./Modal";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);

  const confirm = useCallback(({ title = "Are you sure?", message = "", confirmLabel = "Confirm", tone = "default" } = {}) => {
    return new Promise((resolve) => {
      setState({ title, message, confirmLabel, tone, resolve });
    });
  }, []);

  const close = (result) => {
    state?.resolve(result);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Modal
        open={Boolean(state)}
        onClose={() => close(false)}
        title={state?.title || ""}
        size="sm"
        footer={
          state && (
            <>
              <button type="button" className="ops-button ops-button--secondary" onClick={() => close(false)}>
                Cancel
              </button>
              <button
                type="button"
                className={`ops-button ${state.tone === "danger" ? "ops-button--danger" : "ops-button--primary"}`}
                onClick={() => close(true)}
              >
                {state.confirmLabel}
              </button>
            </>
          )
        }
      >
        {state && <p style={{ color: "var(--ops-muted)", fontSize: 14, lineHeight: 1.6, margin: 0 }}>{state.message}</p>}
      </Modal>
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const context = useContext(ConfirmContext);
  if (!context) throw new Error("useConfirm must be used inside ConfirmProvider");
  return context;
}
